import { PhaseBlock, PhaseBlockConfig } from '@sequencehq/quote-content'
import { CubeDomainInterface } from 'modules/Cube/domain/cube.domain'
import { apiDatesAdapters } from '@sequencehq/utils/dates'
import { priceModelAdapter } from '@sequencehq/utils'
import isObject from 'lodash/fp/isObject'

/**
 * A pricing block holding a copy of the quote's pricing as it stands. That copy
 * is what a reader of the published quote sees, so anything adding a block
 * outside the editor should build it here rather than leave it empty for the
 * editor's next sync to fill in.
 */
export const createPhasesBlock = (
  cubeQueries: CubeDomainInterface['queries']
): PhaseBlock => {
  const resolvedPhaseData = cubeQueries.orderedPhases
  const products = cubeQueries.rawData.data.products

  return {
    blockType: 'phases',
    config: {
      phases: resolvedPhaseData.map(phase => ({
        id: phase.id,
        minimums: phase.minimums,
        name: phase.name,
        discounts: phase.discounts,
        globalDiscount: phase.globalDiscount,
        prices: phase.prices.map(priceModelAdapter.in).map(price => ({
          ...price,
          productDescription: products[price.productId]?.label
        })),
        dates: {
          duration: isObject(phase.dates.duration)
            ? {
                ...phase.dates.duration,
                days:
                  phase.dates.duration?.days === -1
                    ? 0
                    : phase.dates.duration?.days
              }
            : phase.dates.duration,
          absolute: {
            start: apiDatesAdapters.toApi(phase.dates.absolute.start),
            end: apiDatesAdapters.toApi(phase.dates.absolute.end)
          }
        }
      }))
    } as PhaseBlockConfig,
    version: 1
  }
}
